'use strict'

AddressInput = require '../../address_input/frontend/address_input'

module.exports = class GdtWidget

  constructor: ({ el, desktopWrapper, mobileWrapper, @place }) ->
    @rootUrl = '/merchant-page/gdt'

    @$el = $ el
    @$desktopWrapper = $ desktopWrapper
    @$mobileWrapper = $(mobileWrapper) if mobileWrapper?
    @$deliveryOptions = @$el.find 'input[type=radio]'
    @$addressInput = @$el.find '.gdt-address-input-wrapper'
    @$startOrder = @$el.find '.start-order'
    @$notInDeliveryAreaError = @$el.find '.error.not-in-delivery-area'
    @$emptyAddressError = @$el.find '.error.empty-address'

    @addressInput = new AddressInput {
      el: @$addressInput.find '.address-autocomplete'
      onSubmit: @startOrder
      onFocus: @hideErrors
      placeholder: I18n.t 'js.modules.gdt.address_input_placeholder'
    }

    @moveWidget()
    @bindings()
    @selectFirstAvailableOption()

  bindings: ->
    @$deliveryOptions.change @changeDeliveryOption
    @$startOrder.click @startOrder

    debounceTimeout = null
    $(window).on 'resize', =>
      clearTimeout(debounceTimeout) if debounceTimeout?
      debounceTimeout = setTimeout @moveWidget, 250

  moveWidget: =>
    # When this is widget is being used by the Offers Map, there is no @$mobileWrapper
    if @$desktopWrapper.is(':visible') or not @$mobileWrapper?
      return unless @$desktopWrapper.find(@$el).length is 0
      @$desktopWrapper.html @$el
      @$mobileWrapper.find(@$el).remove()
    else if @$mobileWrapper?
      return unless @$mobileWrapper.find(@$el).length is 0
      @$mobileWrapper.html @$el
      @$desktopWrapper.find(@$el).remove()

  getDeliveryOrTakeoutSelection: ->
    value = @$deliveryOptions.filter(':checked').val()

  changeDeliveryOption: =>
    if @getDeliveryOrTakeoutSelection() is 'delivery'
      @$addressInput.slideDown 'fast'
    else
      @$addressInput.slideUp 'fast'
      @hideErrors()

  hideErrors: =>
    @hideErrorEmptyAddress()
    @hideErrorNotInDeliveryArea

  showErrorEmptyAddress: ->
    @$addressInput.addClass 'show-error'
    @$emptyAddressError.show()

  hideErrorEmptyAddress: ->
    @$addressInput.removeClass 'show-error'
    @$emptyAddressError.hide()

  showErrorNotInDeliveryArea: ->
    @$addressInput.addClass 'show-error'
    @$notInDeliveryAreaError.show()

  hideErrorNotInDeliveryArea: ->
    @$addressInput.removeClass 'show-error'
    @$notInDeliveryAreaError.hide()

  isInDeliveryArea: (address, cb) ->
    $.ajax
      url: "#{@rootUrl}/check-delivery-area/#{@place.placeId}"
      type: 'GET'
      contentType: 'application/json'
      dataType: 'json'
      data:
        lat: address.lat
        lon: address.lon
      success: (res) ->
        return cb(new Error("Error Code: #{res?.error?.code}")) unless res?.result is 'ok'
        return cb null, (res.data.isInDeliveryArea is true)
      error: ->
        return cb(new Error('Request Failed'))

  showLoading: ->
    @$el.addClass 'loading'

  hideLoading: ->
    @$el.removeClass 'loading'

  redirectToGdt: (location) ->
    slug = @place.placeSlug ? window.location.pathname.replace /^\/biz\//, ''
    path = "/biz/#{slug}/delivery-takeout?source=mpp"
    path += "&location=#{encodeURIComponent(JSON.stringify(location))}" if location?
    window.location = path

  startOrder: =>
    @showLoading()

    return @redirectToGdt() if @getDeliveryOrTakeoutSelection() is 'takeout'

    if @addressInput.value().length <= 3
      @hideLoading()
      @showErrorEmptyAddress()
      return

    # If any of the two API calls fails, we simply redirect the user to the GDT page
    # without an address and then let them enter the address again on the following page.
    # This way the user is still able to get to the GDT page even if something unexpected goes wrong.

    @addressInput.getAddressDetails (err, address) =>
      return @redirectToGdt() if err?

      @isInDeliveryArea address, (err, isInDeliveryArea) =>
        return @redirectToGdt() if err?

        if not isInDeliveryArea
          @showErrorNotInDeliveryArea()
          @hideLoading()
          return

        location =
          lat: address.lat
          lon: address.lon
          locationString: address.fullAddress
          street: address.street
          locality: address.city
          region: address.state
          postalCode: address.zip
          countryCode: address.countryCode

        @redirectToGdt location

  selectFirstAvailableOption: ->
    for option in @$deliveryOptions
      $option = $ option
      if $option.prop('disabled') isnt true
        $option.prop 'checked', true
        $option.change()
        return
